<template>
    <div class="selected-ages-area pt-100 pb-70" id="siniflarimiz">
        <div class="container">
            <div class="section-title" v-for="title of titles" :key="title.title_id">
                <span class="sub-title">{{ title.title_title }}</span>
                <h2 class="font-weight-black">{{ title.title_header }}</h2>
                <p>{{ title.title_content }}</p>
            </div>
            <div class="row">

                <div class="col-lg-3 col-sm-6 col-md-6" v-for="classItem of classes" :key="classItem.class_id">
                    <div class="single-selected-ages-box">
                        <div class="image">
                            <img :src="getImgUrl('siniflar', classItem.class_img)" alt="image">
                        </div>
                        <div class="content">
                            <h3>{{ classItem.class_header }}</h3>
                            <p>{{ classItem.class_content }}</p>
                            <span class="ages-number">{{ classItem.class_age }}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="kindergarten-shape15">
            <img src="../../assets/img/kindergarten-shape/k-shape15.png" alt="image">
        </div>
        <div class="kindergarten-shape16">
            <img src="../../assets/img/kindergarten-shape/k-shape16.png" alt="image">
        </div>
    </div>
</template>

<script>

import axios from "axios";


export default {
    
    name: 'KidsAges',
    props: ['pathUrl'],

    created() {
      this.getTitles();
      this.getClasses();
    },
    data() {
        return {
            titles: [],
            classes: [],
            errors: []
        };
    },
    methods: {
        getTitles() {
            axios
                .get(this.pathUrl + "?data=title&parent=7")
                    .then(response => (this.titles = response.data.result))
                        .catch(error => {
                             this.errors.push(error);
                        });
         },
         getClasses() {
            axios
                .get(this.pathUrl + "?data=class")
                    .then(response => (this.classes = response.data.result))
                        .catch(error => {
                             this.errors.push(error);
                        });
         },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/'+ category +'/'+ pet)
        }
    }
}


</script>